// ═══════════════════════════════════════════════════════════
// CIVICSENTINEL — SHARED TRANSLATIONS
// All 6 languages for every component
// ═══════════════════════════════════════════════════════════

export const LANGS = [
  { code:"en", native:"English",  flag:"🇬🇧" },
  { code:"hi", native:"हिन्दी",   flag:"🇮🇳" },
  { code:"ta", native:"தமிழ்",    flag:"🇮🇳" },
  { code:"te", native:"తెలుగు",   flag:"🇮🇳" },
  { code:"bn", native:"বাংলা",    flag:"🇮🇳" },
  { code:"mr", native:"मराठी",    flag:"🇮🇳" },
];

export const T = {
  en: {
    // Common
    back:"Back", save:"Save", cancel:"Cancel", or:"or", loading:"Loading...",
    logout:"Logout", submit:"Submit", next:"Next", skip:"Skip", done:"Done",
    close:"Close", edit:"Edit", yes:"Yes", no:"No", error:"Error",
    selectLang:"Select Language", changeLang:"Language",

    // Login
    loginTitle:"Report civic issues\nin your area",
    loginSub:"Photo · GPS · Instant dispatch to ward office",
    email:"Email", password:"Password", fullName:"Full Name",
    signIn:"Sign In", signUp:"Create Account",
    googleLogin:"Continue with Google",
    guestLogin:"Continue as Guest",
    switchToSignUp:"New here? Create account",
    switchToSignIn:"Have account? Sign in",
    terms:"By continuing you agree to our Terms & Privacy Policy",
    forgotPassword:"Forgot password?",
    resetSent:"Password reset email sent! Check your inbox.",
    errEmail:"Enter a valid email",
    errPass:"At least 8 characters",
    errName:"Enter your name",
    ph_email:"you@example.com", ph_pass:"Min 8 characters", ph_name:"Your name",
    passWeak:"Weak", passFair:"Fair", passGood:"Good", passStrong:"Strong",

    // Home
    greeting_morning:"Good Morning", greeting_afternoon:"Good Afternoon", greeting_evening:"Good Evening",
    tagline:"Your voice reaches the ward office instantly.",
    reportBtn:"Report an Issue",
    reportSub:"Photo · GPS · AI Verified · Instant dispatch",
    myReports:"My Reports",
    noReports:"No reports yet. Tap above to report your first issue!",
    newReport:"+ New Report",
    ward:"Ward", city:"City", date:"Date", issue:"Issue", reportId:"Report ID",
    emergency:"Emergency · Call 112",
    alertsBanner:"⚠ Active alerts in your area",
    guestBanner:"You're browsing as a guest. Sign in to submit reports.",
    status_submitted:"Submitted",
    status_in_progress:"In Progress",
    status_resolved:"Resolved ✓",
    status_rejected:"Rejected",

    // Report wizard
    stepPhoto:"Photo", stepGps:"Location", stepAi:"AI Scan",
    stepDetails:"Details", stepSubmit:"Preview", stepDone:"Done",
    takePhoto:"Take a Photo",
    takePhotoSub:"Capture the civic issue clearly",
    uploadPhoto:"Upload from Gallery",
    skipPhoto:"No photo? Skip →",
    skipPhotoNote:"(e.g. no water supply, power cut, noise complaint)",
    retakePhoto:"Retake",
    nextLocation:"Next — Tag Location →",
    detectLocation:"Detect My Location",
    detectingLocation:"Detecting...",
    locationDetected:"Location Detected",
    locationFailed:"Could not detect location. Enter manually.",
    manualLocation:"Or enter location manually",
    ph_location:"Street, Area, City",
    scanningPhoto:"Scanning photo with AI...",
    aiDetected:"AI Detected",
    aiConfidence:"Confidence",
    aiSeverity:"Severity",
    useAiResult:"Use this result",
    changeManually:"Change manually",
    retakeScan:"Retake Photo",
    selectCategory:"Select Issue Category",
    describeIssue:"Describe the issue",
    ph_description:"Describe what you see — the more detail the better...",
    severityLabel:"Severity",
    sev_low:"Low", sev_medium:"Medium", sev_high:"High", sev_critical:"Critical",
    continueToPreview:"Continue to Preview →",
    previewTitle:"Review & Submit",
    field_photo:"Photo", field_location:"Location", field_category:"Category",
    field_aiDetected:"AI Detected", field_description:"Description", field_severity:"Severity",
    aiVerified:"✅ AI Verified", photoSkipped:"⏭ Skipped", manualEntry:"Manual entry",
    submitReport:"🚀 Submit Report",
    submitting:"Submitting...",
    editReport:"← Edit",
    successTitle:"Report Submitted!",
    successSub:"Your complaint has been dispatched to the ward office.",
    reportIdLabel:"Report ID",
    trackingSteps:"What happens next",
    track1:"Ward officer notified", track2:"AI risk scoring complete", track3:"Field inspection assigned",
    submitAnother:"Submit Another Report",
    backToHome:"Back to Home",

    // Profile
    profile:"My Profile",
    editProfile:"Edit Profile",
    memberSince:"Member since",
    language:"Preferred Language",
    myComplaints:"My Complaints",
    noComplaints:"No complaints submitted yet.",
    total:"Total", resolved:"Resolved", pending:"Pending",
    guestUser:"Guest User",
    guestNote:"Sign in to track your complaints and access full features.",
    accountType_email:"Email Account",
    accountType_google:"Google Account",
    savedSuccess:"Saved!",
    status_submitted2:"Submitted",
    status_in_progress2:"In Progress",
    status_resolved2:"Resolved",
    status_rejected2:"Rejected",
  },

  hi: {
    back:"वापस", save:"सहेजें", cancel:"रद्द करें", or:"या", loading:"लोड हो रहा है...",
    logout:"लॉगआउट", submit:"जमा करें", next:"अगला", skip:"छोड़ें", done:"हो गया",
    close:"बंद करें", edit:"संपादित करें", yes:"हाँ", no:"नहीं", error:"त्रुटि",
    selectLang:"भाषा चुनें", changeLang:"भाषा",

    loginTitle:"अपने क्षेत्र में नागरिक\nसमस्याएं रिपोर्ट करें",
    loginSub:"फोटो · GPS · वार्ड कार्यालय को तुरंत भेजें",
    email:"ईमेल", password:"पासवर्ड", fullName:"पूरा नाम",
    signIn:"साइन इन", signUp:"खाता बनाएं",
    googleLogin:"Google से जारी रखें",
    guestLogin:"अतिथि के रूप में जारी रखें",
    switchToSignUp:"नए हैं? खाता बनाएं",
    switchToSignIn:"खाता है? साइन इन",
    terms:"जारी रखकर आप नीतियों से सहमत हैं",
    forgotPassword:"पासवर्ड भूल गए?",
    resetSent:"पासवर्ड रीसेट ईमेल भेजा गया! इनबॉक्स देखें।",
    errEmail:"सही ईमेल दर्ज करें", errPass:"कम से कम 8 अक्षर", errName:"अपना नाम दर्ज करें",
    ph_email:"आपका ईमेल", ph_pass:"कम से कम 8 अक्षर", ph_name:"आपका नाम",
    passWeak:"कमज़ोर", passFair:"ठीक", passGood:"अच्छा", passStrong:"मज़बूत",

    greeting_morning:"शुभ प्रभात", greeting_afternoon:"नमस्कार", greeting_evening:"शुभ संध्या",
    tagline:"आपकी आवाज़ तुरंत वार्ड कार्यालय तक पहुँचती है।",
    reportBtn:"समस्या रिपोर्ट करें",
    reportSub:"फोटो · GPS · AI सत्यापित · तुरंत भेजा",
    myReports:"मेरी रिपोर्ट",
    noReports:"अभी तक कोई रिपोर्ट नहीं। ऊपर टैप करें!",
    newReport:"+ नई रिपोर्ट",
    ward:"वार्ड", city:"शहर", date:"तारीख", issue:"समस्या", reportId:"रिपोर्ट ID",
    emergency:"आपातकाल · 112 पर कॉल करें",
    alertsBanner:"⚠ आपके क्षेत्र में सक्रिय अलर्ट",
    guestBanner:"आप अतिथि के रूप में हैं। रिपोर्ट करने के लिए साइन इन करें।",
    status_submitted:"दर्ज किया", status_in_progress:"प्रगति में", status_resolved:"हल हो गया ✓", status_rejected:"अस्वीकृत",

    stepPhoto:"फोटो", stepGps:"स्थान", stepAi:"AI स्कैन",
    stepDetails:"विवरण", stepSubmit:"पूर्वावलोकन", stepDone:"हो गया",
    takePhoto:"फोटो लें",
    takePhotoSub:"नागरिक समस्या को स्पष्ट रूप से कैप्चर करें",
    uploadPhoto:"गैलरी से अपलोड करें",
    skipPhoto:"फोटो नहीं? छोड़ें →",
    skipPhotoNote:"(जैसे: पानी नहीं, बिजली कट, शोर की शिकायत)",
    retakePhoto:"दोबारा लें",
    nextLocation:"अगला — स्थान टैग करें →",
    detectLocation:"मेरा स्थान पहचानें",
    detectingLocation:"पहचान रहे हैं...",
    locationDetected:"स्थान मिल गया",
    locationFailed:"स्थान नहीं मिला। मैन्युअल दर्ज करें।",
    manualLocation:"या मैन्युअल रूप से दर्ज करें",
    ph_location:"सड़क, क्षेत्र, शहर",
    scanningPhoto:"AI से फोटो स्कैन हो रही है...",
    aiDetected:"AI ने पहचाना",
    aiConfidence:"विश्वसनीयता",
    aiSeverity:"गंभीरता",
    useAiResult:"यह परिणाम उपयोग करें",
    changeManually:"मैन्युअल बदलें",
    retakeScan:"फोटो दोबारा लें",
    selectCategory:"समस्या श्रेणी चुनें",
    describeIssue:"समस्या का विवरण दें",
    ph_description:"आप जो देख रहे हैं उसका वर्णन करें...",
    severityLabel:"गंभीरता",
    sev_low:"कम", sev_medium:"मध्यम", sev_high:"अधिक", sev_critical:"गंभीर",
    continueToPreview:"पूर्वावलोकन जारी रखें →",
    previewTitle:"समीक्षा करें और जमा करें",
    field_photo:"फोटो", field_location:"स्थान", field_category:"श्रेणी",
    field_aiDetected:"AI पहचान", field_description:"विवरण", field_severity:"गंभीरता",
    aiVerified:"✅ AI सत्यापित", photoSkipped:"⏭ छोड़ा गया", manualEntry:"मैन्युअल प्रविष्टि",
    submitReport:"🚀 रिपोर्ट जमा करें",
    submitting:"जमा हो रहा है...",
    editReport:"← संपादित करें",
    successTitle:"रिपोर्ट जमा हो गई!",
    successSub:"आपकी शिकायत वार्ड कार्यालय को भेज दी गई है।",
    reportIdLabel:"रिपोर्ट ID",
    trackingSteps:"आगे क्या होगा",
    track1:"वार्ड अधिकारी को सूचित किया", track2:"AI जोखिम स्कोरिंग पूर्ण", track3:"फील्ड निरीक्षण सौंपा",
    submitAnother:"एक और रिपोर्ट करें",
    backToHome:"होम पर वापस",

    profile:"मेरी प्रोफ़ाइल", editProfile:"प्रोफ़ाइल संपादित करें",
    memberSince:"सदस्य बने", language:"पसंदीदा भाषा",
    myComplaints:"मेरी शिकायतें", noComplaints:"अभी तक कोई शिकायत नहीं।",
    total:"कुल", resolved:"हल", pending:"बकाया",
    guestUser:"अतिथि उपयोगकर्ता",
    guestNote:"शिकायतें ट्रैक करने के लिए साइन इन करें।",
    accountType_email:"ईमेल खाता", accountType_google:"Google खाता",
    savedSuccess:"सहेजा गया!",
    status_submitted2:"दर्ज", status_in_progress2:"प्रगति में", status_resolved2:"हल", status_rejected2:"अस्वीकृत",
  },

  ta: {
    back:"திரும்பு", save:"சேமி", cancel:"ரத்து செய்", or:"அல்லது", loading:"ஏற்றுகிறது...",
    logout:"வெளியேறு", submit:"சமர்ப்பி", next:"அடுத்து", skip:"தவிர்", done:"முடிந்தது",
    close:"மூடு", edit:"திருத்து", yes:"ஆம்", no:"இல்லை", error:"பிழை",
    selectLang:"மொழி தேர்வு", changeLang:"மொழி",

    loginTitle:"உங்கள் பகுதியில் பிரச்சினைகளை\nபுகார் செய்யுங்கள்",
    loginSub:"படம் · GPS · உடனடி அனுப்புதல்",
    email:"மின்னஞ்சல்", password:"கடவுச்சொல்", fullName:"முழு பெயர்",
    signIn:"உள்நுழை", signUp:"கணக்கு உருவாக்கு",
    googleLogin:"Google மூலம் தொடர்",
    guestLogin:"விருந்தினராக தொடர்",
    switchToSignUp:"புதியவரா? கணக்கு உருவாக்கு",
    switchToSignIn:"கணக்கு உள்ளதா? உள்நுழை",
    terms:"தொடர்வதன் மூலம் நீங்கள் ஒப்புக்கொள்கிறீர்கள்",
    forgotPassword:"கடவுச்சொல் மறந்துவிட்டதா?",
    resetSent:"மீட்டமைப்பு மின்னஞ்சல் அனுப்பப்பட்டது!",
    errEmail:"சரியான மின்னஞ்சல்", errPass:"குறைந்தது 8 எழுத்துகள்", errName:"உங்கள் பெயரை உள்ளிடுக",
    ph_email:"உங்கள் மின்னஞ்சல்", ph_pass:"குறைந்தது 8 எழுத்துகள்", ph_name:"உங்கள் பெயர்",
    passWeak:"பலவீனம்", passFair:"சரி", passGood:"நல்லது", passStrong:"வலிமை",

    greeting_morning:"காலை வணக்கம்", greeting_afternoon:"மதிய வணக்கம்", greeting_evening:"மாலை வணக்கம்",
    tagline:"உங்கள் குரல் உடனடியாக வார்டு அலுவலகம் சேரும்.",
    reportBtn:"பிரச்சினையை புகார் செய்",
    reportSub:"படம் · GPS · AI சரிபார்க்கப்பட்டது",
    myReports:"என் புகார்கள்",
    noReports:"இன்னும் புகார்கள் இல்லை. மேலே தட்டவும்!",
    newReport:"+ புதிய புகார்",
    ward:"வார்டு", city:"நகரம்", date:"தேதி", issue:"பிரச்சினை", reportId:"புகார் ID",
    emergency:"அவசரநிலை · 112 அழைக்கவும்",
    alertsBanner:"⚠ உங்கள் பகுதியில் எச்சரிக்கைகள்",
    guestBanner:"நீங்கள் விருந்தினராக உள்ளீர்கள். புகார் செய்ய உள்நுழையவும்.",
    status_submitted:"சமர்ப்பிக்கப்பட்டது", status_in_progress:"செயலில்", status_resolved:"தீர்க்கப்பட்டது ✓", status_rejected:"நிராகரிக்கப்பட்டது",

    stepPhoto:"படம்", stepGps:"இடம்", stepAi:"AI ஸ்கேன்",
    stepDetails:"விவரங்கள்", stepSubmit:"முன்னோட்டம்", stepDone:"முடிந்தது",
    takePhoto:"படம் எடு",
    takePhotoSub:"பிரச்சினையை தெளிவாக படம் எடுக்கவும்",
    uploadPhoto:"கேலரியிலிருந்து பதிவேற்று",
    skipPhoto:"படம் இல்லையா? தவிர் →",
    skipPhotoNote:"(எ.கா: தண்ணீர் இல்லை, மின்சாரம் இல்லை)",
    retakePhoto:"மீண்டும் எடு",
    nextLocation:"அடுத்து — இடத்தை குறி →",
    detectLocation:"என் இடத்தை கண்டறி",
    detectingLocation:"கண்டறிகிறது...",
    locationDetected:"இடம் கண்டறியப்பட்டது",
    locationFailed:"இடம் கண்டறிய முடியவில்லை. கைமுறையாக உள்ளிடவும்.",
    manualLocation:"அல்லது கைமுறையாக உள்ளிடவும்",
    ph_location:"தெரு, பகுதி, நகரம்",
    scanningPhoto:"AI படத்தை ஸ்கேன் செய்கிறது...",
    aiDetected:"AI கண்டறிந்தது",
    aiConfidence:"நம்பகத்தன்மை",
    aiSeverity:"தீவிரம்",
    useAiResult:"இந்த முடிவை பயன்படுத்து",
    changeManually:"கைமுறையாக மாற்று",
    retakeScan:"படம் மீண்டும் எடு",
    selectCategory:"வகையைத் தேர்ந்தெடு",
    describeIssue:"பிரச்சினையை விவரி",
    ph_description:"நீங்கள் பார்ப்பதை விவரிக்கவும்...",
    severityLabel:"தீவிரம்",
    sev_low:"குறைவு", sev_medium:"நடுத்தரம்", sev_high:"அதிகம்", sev_critical:"மிகவும் தீவிரம்",
    continueToPreview:"முன்னோட்டம் →",
    previewTitle:"சரிபார்த்து சமர்ப்பி",
    field_photo:"படம்", field_location:"இடம்", field_category:"வகை",
    field_aiDetected:"AI கண்டறிதல்", field_description:"விவரம்", field_severity:"தீவிரம்",
    aiVerified:"✅ AI சரிபார்க்கப்பட்டது", photoSkipped:"⏭ தவிர்க்கப்பட்டது", manualEntry:"கைமுறை பதிவு",
    submitReport:"🚀 புகார் சமர்ப்பி",
    submitting:"சமர்ப்பிக்கிறது...",
    editReport:"← திருத்து",
    successTitle:"புகார் சமர்ப்பிக்கப்பட்டது!",
    successSub:"உங்கள் புகார் வார்டு அலுவலகத்திற்கு அனுப்பப்பட்டது.",
    reportIdLabel:"புகார் ID",
    trackingSteps:"அடுத்து என்ன நடக்கும்",
    track1:"வார்டு அதிகாரிக்கு அறிவிக்கப்பட்டது", track2:"AI ஆபத்து மதிப்பீடு முடிந்தது", track3:"களப் பரிசோதனை ஒதுக்கப்பட்டது",
    submitAnother:"மற்றொரு புகார் செய்",
    backToHome:"முகப்பிற்கு திரும்பு",

    profile:"என் சுயவிவரம்", editProfile:"சுயவிவரம் திருத்து",
    memberSince:"உறுப்பினர் ஆனது", language:"விரும்பிய மொழி",
    myComplaints:"என் புகார்கள்", noComplaints:"இன்னும் புகார்கள் இல்லை.",
    total:"மொத்தம்", resolved:"தீர்க்கப்பட்டது", pending:"நிலுவை",
    guestUser:"விருந்தினர்",
    guestNote:"புகார்களை கண்காணிக்க உள்நுழையவும்.",
    accountType_email:"மின்னஞ்சல் கணக்கு", accountType_google:"Google கணக்கு",
    savedSuccess:"சேமிக்கப்பட்டது!",
    status_submitted2:"சமர்ப்பிக்கப்பட்டது", status_in_progress2:"செயலில்", status_resolved2:"தீர்க்கப்பட்டது", status_rejected2:"நிராகரிக்கப்பட்டது",
  },

  te: {
    back:"వెనుకకు", save:"సేవ్ చేయి", cancel:"రద్దు చేయి", or:"లేదా", loading:"లోడవుతోంది...",
    logout:"లాగ్అవుట్", submit:"సమర్పించు", next:"తదుపరి", skip:"దాటవేయి", done:"పూర్తయింది",
    close:"మూసివేయి", edit:"సవరించు", yes:"అవును", no:"కాదు", error:"లోపం",
    selectLang:"భాష ఎంచుకోండి", changeLang:"భాష",

    loginTitle:"మీ ప్రాంతంలో సమస్యలను\nనివేదించండి",
    loginSub:"ఫోటో · GPS · వార్డ్ కార్యాలయానికి తక్షణ పంపుట",
    email:"ఇమెయిల్", password:"పాస్‌వర్డ్", fullName:"పూర్తి పేరు",
    signIn:"సైన్ ఇన్", signUp:"ఖాతా తెరవండి",
    googleLogin:"Google తో కొనసాగండి",
    guestLogin:"అతిథిగా కొనసాగండి",
    switchToSignUp:"కొత్తవారా? ఖాతా తెరవండి",
    switchToSignIn:"ఖాతా ఉందా? సైన్ ఇన్",
    terms:"కొనసాగడం ద్వారా మీరు అంగీకరిస్తున్నారు",
    forgotPassword:"పాస్‌వర్డ్ మర్చిపోయారా?",
    resetSent:"రీసెట్ ఇమెయిల్ పంపబడింది!",
    errEmail:"సరైన ఇమెయిల్", errPass:"కనీసం 8 అక్షరాలు", errName:"మీ పేరు నమోదు చేయండి",
    ph_email:"మీ ఇమెయిల్", ph_pass:"కనీసం 8 అక్షరాలు", ph_name:"మీ పేరు",
    passWeak:"బలహీనం", passFair:"సరి", passGood:"మంచిది", passStrong:"బలమైనది",

    greeting_morning:"శుభోదయం", greeting_afternoon:"నమస్కారం", greeting_evening:"శుభ సాయంత్రం",
    tagline:"మీ మాట వెంటనే వార్డ్ కార్యాలయానికి చేరుతుంది.",
    reportBtn:"సమస్య నివేదించండి",
    reportSub:"ఫోటో · GPS · AI ధృవీకరించబడింది",
    myReports:"నా నివేదికలు",
    noReports:"ఇంకా నివేదికలు లేవు. పైన నొక్కండి!",
    newReport:"+ కొత్త నివేదిక",
    ward:"వార్డ్", city:"నగరం", date:"తేదీ", issue:"సమస్య", reportId:"నివేదిక ID",
    emergency:"అత్యవసరం · 112 కాల్ చేయండి",
    alertsBanner:"⚠ మీ ప్రాంతంలో హెచ్చరికలు",
    guestBanner:"మీరు అతిథిగా ఉన్నారు. నివేదించడానికి సైన్ ఇన్ చేయండి.",
    status_submitted:"సమర్పించబడింది", status_in_progress:"పురోగతిలో", status_resolved:"పరిష్కరించబడింది ✓", status_rejected:"తిరస్కరించబడింది",

    stepPhoto:"ఫోటో", stepGps:"స్థలం", stepAi:"AI స్కాన్",
    stepDetails:"వివరాలు", stepSubmit:"పరిశీలన", stepDone:"పూర్తయింది",
    takePhoto:"ఫోటో తీయండి",
    takePhotoSub:"సమస్యను స్పష్టంగా ఫోటో తీయండి",
    uploadPhoto:"గ్యాలరీ నుండి అప్‌లోడ్",
    skipPhoto:"ఫోటో లేదా? దాటవేయండి →",
    skipPhotoNote:"(ఉదా: నీరు లేదు, కరెంట్ పోయింది)",
    retakePhoto:"మళ్ళీ తీయండి",
    nextLocation:"తదుపరి — స్థానం టాగ్ చేయండి →",
    detectLocation:"నా స్థానం గుర్తించు",
    detectingLocation:"గుర్తిస్తోంది...",
    locationDetected:"స్థానం గుర్తించబడింది",
    locationFailed:"స్థానం గుర్తించలేకపోయింది. మాన్యువల్‌గా నమోదు చేయండి.",
    manualLocation:"లేదా మాన్యువల్‌గా నమోదు చేయండి",
    ph_location:"వీధి, ప్రాంతం, నగరం",
    scanningPhoto:"AI ఫోటో స్కాన్ చేస్తోంది...",
    aiDetected:"AI గుర్తించింది",
    aiConfidence:"నమ్మకం",
    aiSeverity:"తీవ్రత",
    useAiResult:"ఈ ఫలితాన్ని ఉపయోగించు",
    changeManually:"మాన్యువల్‌గా మార్చు",
    retakeScan:"ఫోటో మళ్ళీ తీయండి",
    selectCategory:"సమస్య వర్గం ఎంచుకోండి",
    describeIssue:"సమస్యను వివరించండి",
    ph_description:"మీరు చూస్తున్నది వివరించండి...",
    severityLabel:"తీవ్రత",
    sev_low:"తక్కువ", sev_medium:"మధ్యస్థం", sev_high:"అధికం", sev_critical:"అత్యంత తీవ్రం",
    continueToPreview:"పరిశీలనకు కొనసాగు →",
    previewTitle:"సమీక్షించి సమర్పించు",
    field_photo:"ఫోటో", field_location:"స్థానం", field_category:"వర్గం",
    field_aiDetected:"AI గుర్తింపు", field_description:"వివరణ", field_severity:"తీవ్రత",
    aiVerified:"✅ AI ధృవీకరించబడింది", photoSkipped:"⏭ దాటవేయబడింది", manualEntry:"మాన్యువల్ నమోదు",
    submitReport:"🚀 నివేదిక సమర్పించు",
    submitting:"సమర్పిస్తోంది...",
    editReport:"← సవరించు",
    successTitle:"నివేదిక సమర్పించబడింది!",
    successSub:"మీ ఫిర్యాదు వార్డ్ కార్యాలయానికి పంపబడింది.",
    reportIdLabel:"నివేదిక ID",
    trackingSteps:"తదుపరి ఏమి జరుగుతుంది",
    track1:"వార్డ్ అధికారికి తెలియజేయబడింది", track2:"AI రిస్క్ స్కోరింగ్ పూర్తయింది", track3:"ఫీల్డ్ తనిఖీ నియమించబడింది",
    submitAnother:"మరొక నివేదిక చేయండి",
    backToHome:"హోమ్‌కు వెళ్ళు",

    profile:"నా ప్రొఫైల్", editProfile:"ప్రొఫైల్ సవరించు",
    memberSince:"సభ్యుడైన తేదీ", language:"ఇష్టపడే భాష",
    myComplaints:"నా ఫిర్యాదులు", noComplaints:"ఇంకా ఫిర్యాదులు లేవు.",
    total:"మొత్తం", resolved:"పరిష్కరించబడింది", pending:"పెండింగ్",
    guestUser:"అతిథి వినియోగదారు",
    guestNote:"ఫిర్యాదులు ట్రాక్ చేయడానికి సైన్ ఇన్ చేయండి.",
    accountType_email:"ఇమెయిల్ ఖాతా", accountType_google:"Google ఖాతా",
    savedSuccess:"సేవ్ అయింది!",
    status_submitted2:"సమర్పించబడింది", status_in_progress2:"పురోగతిలో", status_resolved2:"పరిష్కరించబడింది", status_rejected2:"తిరస్కరించబడింది",
  },

  bn: {
    back:"ফিরুন", save:"সংরক্ষণ করুন", cancel:"বাতিল করুন", or:"অথবা", loading:"লোড হচ্ছে...",
    logout:"লগআউট", submit:"জমা দিন", next:"পরবর্তী", skip:"এড়িয়ে যান", done:"সম্পন্ন",
    close:"বন্ধ করুন", edit:"সম্পাদনা করুন", yes:"হ্যাঁ", no:"না", error:"ত্রুটি",
    selectLang:"ভাষা নির্বাচন করুন", changeLang:"ভাষা",

    loginTitle:"আপনার এলাকায় সমস্যা\nরিপোর্ট করুন",
    loginSub:"ফটো · GPS · ওয়ার্ড অফিসে তাৎক্ষণিক প্রেরণ",
    email:"ইমেইল", password:"পাসওয়ার্ড", fullName:"পুরো নাম",
    signIn:"সাইন ইন", signUp:"অ্যাকাউন্ট তৈরি করুন",
    googleLogin:"Google দিয়ে চালিয়ে যান",
    guestLogin:"অতিথি হিসেবে চালিয়ে যান",
    switchToSignUp:"নতুন? অ্যাকাউন্ট তৈরি করুন",
    switchToSignIn:"অ্যাকাউন্ট আছে? সাইন ইন",
    terms:"চালিয়ে যাওয়ার মাধ্যমে আপনি সম্মত হচ্ছেন",
    forgotPassword:"পাসওয়ার্ড ভুলে গেছেন?",
    resetSent:"রিসেট ইমেইল পাঠানো হয়েছে!",
    errEmail:"সঠিক ইমেইল দিন", errPass:"কমপক্ষে ৮ অক্ষর", errName:"আপনার নাম দিন",
    ph_email:"আপনার ইমেইল", ph_pass:"কমপক্ষে ৮ অক্ষর", ph_name:"আপনার নাম",
    passWeak:"দুর্বল", passFair:"মোটামুটি", passGood:"ভালো", passStrong:"শক্তিশালী",

    greeting_morning:"শুভ সকাল", greeting_afternoon:"শুভ অপরাহ্ণ", greeting_evening:"শুভ সন্ধ্যা",
    tagline:"আপনার কণ্ঠস্বর সঙ্গে সঙ্গে ওয়ার্ড অফিসে পৌঁছায়।",
    reportBtn:"সমস্যা রিপোর্ট করুন",
    reportSub:"ফটো · GPS · AI যাচাই করা হয়েছে",
    myReports:"আমার রিপোর্ট",
    noReports:"এখনো কোনো রিপোর্ট নেই। উপরে ট্যাপ করুন!",
    newReport:"+ নতুন রিপোর্ট",
    ward:"ওয়ার্ড", city:"শহর", date:"তারিখ", issue:"সমস্যা", reportId:"রিপোর্ট ID",
    emergency:"জরুরি · 112 কল করুন",
    alertsBanner:"⚠ আপনার এলাকায় সক্রিয় সতর্কতা",
    guestBanner:"আপনি অতিথি হিসেবে আছেন। রিপোর্ট করতে সাইন ইন করুন।",
    status_submitted:"জমা দেওয়া হয়েছে", status_in_progress:"চলমান", status_resolved:"সমাধান হয়েছে ✓", status_rejected:"প্রত্যাখ্যাত",

    stepPhoto:"ফটো", stepGps:"অবস্থান", stepAi:"AI স্ক্যান",
    stepDetails:"বিবরণ", stepSubmit:"পর্যালোচনা", stepDone:"সম্পন্ন",
    takePhoto:"ফটো তুলুন",
    takePhotoSub:"সমস্যাটি স্পষ্টভাবে ক্যাপচার করুন",
    uploadPhoto:"গ্যালারি থেকে আপলোড করুন",
    skipPhoto:"ফটো নেই? এড়িয়ে যান →",
    skipPhotoNote:"(যেমন: পানি নেই, বিদ্যুৎ বিভ্রাট)",
    retakePhoto:"আবার তুলুন",
    nextLocation:"পরবর্তী — অবস্থান ট্যাগ করুন →",
    detectLocation:"আমার অবস্থান শনাক্ত করুন",
    detectingLocation:"শনাক্ত করা হচ্ছে...",
    locationDetected:"অবস্থান শনাক্ত হয়েছে",
    locationFailed:"অবস্থান পাওয়া যায়নি। ম্যানুয়ালি লিখুন।",
    manualLocation:"অথবা ম্যানুয়ালি লিখুন",
    ph_location:"রাস্তা, এলাকা, শহর",
    scanningPhoto:"AI ফটো স্ক্যান করছে...",
    aiDetected:"AI শনাক্ত করেছে",
    aiConfidence:"আস্থা",
    aiSeverity:"তীব্রতা",
    useAiResult:"এই ফলাফল ব্যবহার করুন",
    changeManually:"ম্যানুয়ালি পরিবর্তন করুন",
    retakeScan:"ফটো আবার তুলুন",
    selectCategory:"সমস্যার বিভাগ নির্বাচন করুন",
    describeIssue:"সমস্যাটি বর্ণনা করুন",
    ph_description:"আপনি যা দেখছেন তা বর্ণনা করুন...",
    severityLabel:"তীব্রতা",
    sev_low:"কম", sev_medium:"মাঝারি", sev_high:"বেশি", sev_critical:"সংকটজনক",
    continueToPreview:"পর্যালোচনায় যান →",
    previewTitle:"পর্যালোচনা ও জমা দিন",
    field_photo:"ফটো", field_location:"অবস্থান", field_category:"বিভাগ",
    field_aiDetected:"AI শনাক্তকরণ", field_description:"বিবরণ", field_severity:"তীব্রতা",
    aiVerified:"✅ AI যাচাইকৃত", photoSkipped:"⏭ এড়িয়ে গেছে", manualEntry:"ম্যানুয়াল এন্ট্রি",
    submitReport:"🚀 রিপোর্ট জমা দিন",
    submitting:"জমা দেওয়া হচ্ছে...",
    editReport:"← সম্পাদনা",
    successTitle:"রিপোর্ট জমা হয়েছে!",
    successSub:"আপনার অভিযোগ ওয়ার্ড অফিসে পাঠানো হয়েছে।",
    reportIdLabel:"রিপোর্ট ID",
    trackingSteps:"পরবর্তীতে কী হবে",
    track1:"ওয়ার্ড অফিসারকে জানানো হয়েছে", track2:"AI ঝুঁকি স্কোরিং সম্পন্ন", track3:"ফিল্ড পরিদর্শন নির্ধারিত",
    submitAnother:"আরেকটি রিপোর্ট করুন",
    backToHome:"হোমে ফিরুন",

    profile:"আমার প্রোফাইল", editProfile:"প্রোফাইল সম্পাদনা",
    memberSince:"সদস্য হয়েছেন", language:"পছন্দের ভাষা",
    myComplaints:"আমার অভিযোগ", noComplaints:"এখনো কোনো অভিযোগ নেই।",
    total:"মোট", resolved:"সমাধান", pending:"অমীমাংসিত",
    guestUser:"অতিথি ব্যবহারকারী",
    guestNote:"অভিযোগ ট্র্যাক করতে সাইন ইন করুন।",
    accountType_email:"ইমেইল অ্যাকাউন্ট", accountType_google:"Google অ্যাকাউন্ট",
    savedSuccess:"সংরক্ষিত!",
    status_submitted2:"জমা", status_in_progress2:"চলমান", status_resolved2:"সমাধান", status_rejected2:"প্রত্যাখ্যাত",
  },

  mr: {
    back:"मागे", save:"जतन करा", cancel:"रद्द करा", or:"किंवा", loading:"लोड होत आहे...",
    logout:"लॉगआउट", submit:"सबमिट करा", next:"पुढे", skip:"वगळा", done:"झाले",
    close:"बंद करा", edit:"संपादित करा", yes:"हो", no:"नाही", error:"त्रुटी",
    selectLang:"भाषा निवडा", changeLang:"भाषा",

    loginTitle:"तुमच्या परिसरातील समस्या\nनोंदवा",
    loginSub:"फोटो · GPS · वार्ड कार्यालयाला त्वरित पाठवा",
    email:"ईमेल", password:"पासवर्ड", fullName:"पूर्ण नाव",
    signIn:"साइन इन", signUp:"खाते तयार करा",
    googleLogin:"Google सह सुरू ठेवा",
    guestLogin:"पाहुणे म्हणून सुरू ठेवा",
    switchToSignUp:"नवीन? खाते तयार करा",
    switchToSignIn:"खाते आहे? साइन इन",
    terms:"सुरू ठेवल्यास तुम्ही सहमत आहात",
    forgotPassword:"पासवर्ड विसरलात?",
    resetSent:"रीसेट ईमेल पाठवला गेला!",
    errEmail:"योग्य ईमेल प्रविष्ट करा", errPass:"किमान 8 अक्षरे", errName:"तुमचे नाव प्रविष्ट करा",
    ph_email:"तुमचा ईमेल", ph_pass:"किमान 8 अक्षरे", ph_name:"तुमचे नाव",
    passWeak:"कमकुवत", passFair:"बरे", passGood:"चांगले", passStrong:"मजबूत",

    greeting_morning:"सुप्रभात", greeting_afternoon:"नमस्कार", greeting_evening:"शुभ संध्या",
    tagline:"तुमचा आवाज तत्काळ वार्ड कार्यालयापर्यंत पोहोचतो.",
    reportBtn:"समस्या नोंदवा",
    reportSub:"फोटो · GPS · AI सत्यापित · त्वरित पाठवले",
    myReports:"माझ्या तक्रारी",
    noReports:"अद्याप तक्रारी नाहीत. वर टॅप करा!",
    newReport:"+ नवीन तक्रार",
    ward:"वार्ड", city:"शहर", date:"तारीख", issue:"समस्या", reportId:"तक्रार ID",
    emergency:"आणीबाणी · 112 वर कॉल करा",
    alertsBanner:"⚠ तुमच्या परिसरात सक्रिय सूचना",
    guestBanner:"तुम्ही पाहुणे म्हणून आहात. तक्रार नोंदवण्यासाठी साइन इन करा.",
    status_submitted:"सादर केले", status_in_progress:"प्रगतीपथावर", status_resolved:"निराकरण झाले ✓", status_rejected:"नाकारले",

    stepPhoto:"फोटो", stepGps:"स्थान", stepAi:"AI स्कॅन",
    stepDetails:"तपशील", stepSubmit:"पूर्वावलोकन", stepDone:"झाले",
    takePhoto:"फोटो घ्या",
    takePhotoSub:"समस्या स्पष्टपणे कॅप्चर करा",
    uploadPhoto:"गॅलरीतून अपलोड करा",
    skipPhoto:"फोटो नाही? वगळा →",
    skipPhotoNote:"(उदा: पाणी नाही, वीज खंडित, आवाजाची तक्रार)",
    retakePhoto:"पुन्हा घ्या",
    nextLocation:"पुढे — स्थान टॅग करा →",
    detectLocation:"माझे स्थान शोधा",
    detectingLocation:"शोधत आहे...",
    locationDetected:"स्थान सापडले",
    locationFailed:"स्थान सापडले नाही. मॅन्युअल प्रविष्ट करा.",
    manualLocation:"किंवा मॅन्युअल प्रविष्ट करा",
    ph_location:"रस्ता, परिसर, शहर",
    scanningPhoto:"AI फोटो स्कॅन करत आहे...",
    aiDetected:"AI ने ओळखले",
    aiConfidence:"विश्वासार्हता",
    aiSeverity:"तीव्रता",
    useAiResult:"हा निकाल वापरा",
    changeManually:"मॅन्युअल बदला",
    retakeScan:"फोटो पुन्हा घ्या",
    selectCategory:"समस्येची श्रेणी निवडा",
    describeIssue:"समस्येचे वर्णन करा",
    ph_description:"तुम्ही काय पाहत आहात ते वर्णन करा...",
    severityLabel:"तीव्रता",
    sev_low:"कमी", sev_medium:"मध्यम", sev_high:"जास्त", sev_critical:"गंभीर",
    continueToPreview:"पूर्वावलोकनावर जा →",
    previewTitle:"पुनरावलोकन करा आणि सबमिट करा",
    field_photo:"फोटो", field_location:"स्थान", field_category:"श्रेणी",
    field_aiDetected:"AI ओळख", field_description:"वर्णन", field_severity:"तीव्रता",
    aiVerified:"✅ AI सत्यापित", photoSkipped:"⏭ वगळले", manualEntry:"मॅन्युअल प्रविष्टी",
    submitReport:"🚀 तक्रार सबमिट करा",
    submitting:"सबमिट होत आहे...",
    editReport:"← संपादित करा",
    successTitle:"तक्रार सबमिट झाली!",
    successSub:"तुमची तक्रार वार्ड कार्यालयाला पाठवली गेली आहे.",
    reportIdLabel:"तक्रार ID",
    trackingSteps:"पुढे काय होईल",
    track1:"वार्ड अधिकाऱ्याला कळवले", track2:"AI जोखीम स्कोरिंग पूर्ण", track3:"फील्ड तपासणी नियुक्त",
    submitAnother:"आणखी एक तक्रार करा",
    backToHome:"होमवर परत",

    profile:"माझी प्रोफाइल", editProfile:"प्रोफाइल संपादित करा",
    memberSince:"सदस्य झाले", language:"पसंतीची भाषा",
    myComplaints:"माझ्या तक्रारी", noComplaints:"अद्याप तक्रारी नाहीत.",
    total:"एकूण", resolved:"निराकरण", pending:"प्रलंबित",
    guestUser:"पाहुणे वापरकर्ता",
    guestNote:"तक्रारी ट्रॅक करण्यासाठी साइन इन करा.",
    accountType_email:"ईमेल खाते", accountType_google:"Google खाते",
    savedSuccess:"जतन झाले!",
    status_submitted2:"सादर", status_in_progress2:"प्रगतीपथावर", status_resolved2:"निराकरण", status_rejected2:"नाकारले",
  },
};

export const tl = (lang, key) => (T[lang] || T.en)[key] ?? T.en[key] ?? key;